import React from 'react';
import ReactDOM from 'react-dom';
import FsgoItems from './FsgoItems';
import FsgoVideosService from '../FsgoVideosService';
import { settings } from '../constants';

class Fsgo extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isDataFetched: false
		};
	}

	componentWillMount(){
		performance.mark(`fsgo[${this.props.componentId}]-componentWillMount`);
	}

	componentDidUpdate(){
		performance.mark(`fsgo[${this.props.componentId}]-componentDidUpdate`);
	}

	componentDidMount() {
		performance.mark(`fsgo[${this.props.componentId}]-componentDidMount`);
		performance.mark(`fsgo[${this.props.componentId}]-getVideos`);

		FsgoVideosService.getVideos(this.props.regionalIds, this.props.postType === settings.SF_POST_TYPE).then(videos => {
			performance.mark(`fsgo[${this.props.componentId}]-setState`);
			this.setState(() => ({
				isDataFetched: true,
				allLiveVideosCount: videos.allLiveVideosCount,
				liveVideos: videos.liveVideos,
				featureVideos: videos.featureVideos,
				regionNames: videos.regionNames
			}))
		})
	}

	getContainerClass() {
		if (this.props.title) {
			return '';
		}

		if (FsgoVideosService.isViewAllSeparatorShown(this.state.regionNames, true)) {
			return 'align-videos';
		}

		return 'align-title';
	}

	render() {
		return (
			<div>
				{this.state.isDataFetched &&
					(
						<div className={this.getContainerClass()}>
							{this.props.title &&
								<div className="fsgo-title-container">
									<h3 className="sidebar-component-title">{this.props.title}</h3>
									<span className="separator"></span>
								</div>
							}

							<div className="fs-go-sidebar-container">
								<ul className="tune-in-list">
									{this.state.liveVideos.length > 0 &&
										<FsgoItems items={this.state.liveVideos}
												   state="live"
												   title="LIVE NOW"
												   isPost={this.props.postType !== settings.SF_POST_TYPE}
                                                   postType={this.props.postType}
												   regionNames={this.state.regionNames}
												   allCount={this.state.allLiveVideosCount}/>
									}
									{this.state.featureVideos.length > 0 &&
										<FsgoItems items={this.state.featureVideos}
												   state="featured"
												   title="FEATURED"
												   isPost={this.props.postType !== settings.SF_POST_TYPE}
												   postType={this.props.postType}
												   regionNames={this.state.regionNames}/>
									}
								</ul>
							</div>
						</div>
					)
				}
			</div>
		);
	}
}

let renderFsgo = function(id) {
	let mountNode = document.getElementById(id);

	if (mountNode) {
		performance.mark(`fsgo[0]-render-start`);
		let title = mountNode.getAttribute('title');
		let regionalIds = mountNode.getAttribute('regional-ids');
		let postType = mountNode.getAttribute('post-type');
		ReactDOM.render(<Fsgo title={title} regionalIds={regionalIds} postType={postType} componentId={0}/>, mountNode);
	}
}

let mountNodes = document.getElementsByTagName('Fsgo');

if (mountNodes) {
	for (let i = 0; i < mountNodes.length; i++){
		let mountNode = mountNodes[i];
		renderFsgo(mountNode.getAttribute('id'));
	}
}

window.renderFsgo = renderFsgo;



// WEBPACK FOOTER //
// ./react-app-src/fsgo/components/Fsgo.js